// Тексты настроек платформы и функций (CFG-UC-1…3).
export const ru = {
  config: {
    title: 'Настройки платформы',
    docRefs: {
      label: 'Где искать пояснение',
      heading: 'Пояснение — в документации проекта:',
      line: '{ref} — {kind}',
      kinds: { usecase: 'юзкейс', case: 'крайний случай юзкейса', rule: 'правило', adr: 'архитектурное решение (ADR)' },
    },
    subtitle: 'Параметры работы сервера и интерфейса. Сохранённое здесь перекрывает окружение сервера.',
    search: 'Поиск по описанию и ключу',
    searchHint: 'Ключ, слова ключа, описание или GR_…',
    onlyChanged: 'Только изменённые',
    found: 'Показано {shown} из {total}',
    nothingFound: 'Ничего не найдено',
    groups: { primary: 'Основные', secondary: 'Второстепенные' },
    on: 'Включено',
    off: 'Выключено',
    sections: {
      features: 'Функции',
      server: 'Сервер',
      database: 'База данных',
      storage: 'Хранилище файлов',
      media: 'Медиа',
      auth: 'Вход и сессии',
      initialData: 'Первый запуск',
      jobs: 'Периодические задания',
      tasks: 'Фоновые задачи',
      coordination: 'Несколько инстансов',
      realtime: 'События в реальном времени',
      demo: 'Демо',
      testMode: 'Тестовый режим',
      ui: 'Интерфейс',
    },
    sources: { default: 'По умолчанию', env: 'Окружение сервера', saved: 'Сохранено' },
    restartApply: 'С перезапуска',
    pendingRestart: 'Ждёт перезапуска',
    envOnly: 'Только окружение',
    secret: 'Секрет',
    secretSet: 'Задано',
    notSet: 'Не задано',
    afterRestart: 'После перезапуска',
    envOverridden: 'Окружение {env} — перекрыто',
    envName: 'Переменная окружения',
    saved: 'Сохранено',
    savedBy: '{value} — {login}, {at}',
    defaultValue: 'По умолчанию',
    savedInvalid: 'Сохранённое значение недопустимо и не применяется: действует окружение или значение по умолчанию.',
    envOnlyHint: 'Меняется только окружением сервера ({env}) и перезапуском.',
    notSaved: 'Не сохранено',
    savedWithWarnings: 'Сохранено',
    warnings: {
      ENV_OVERRIDDEN: 'Значение перекрывает переменную окружения {env}: пока сохранённое не сброшено, она не действует.',
      RESTART_REQUIRED: 'Подействует после перезапуска сервера.',
    },
    reset: 'Сбросить сохранённое',
    personal: 'Личный',
    personalHint: 'Пользователь может задать себе своё значение в профиле — оно перекрывает это.',
    readOnlyTitle: 'Демо-режим: только просмотр',
    readOnly: 'Демо общее для всех посетителей и работает на сервере рядом с рабочей системой, поэтому настройки платформы здесь не меняются.',
    enabled: 'Включено',
    range: 'От {min} до {max}',
    listRange: 'От {minItems} до {maxItems} чисел через запятую, каждое от {min} до {max}',
    units: { ms: 'мс', seconds: 'с', minutes: 'мин', hours: 'ч', kb: 'КБ', mb: 'МБ', gb: 'ГБ', px: 'px' },
  },
};

export const en: typeof ru = {
  config: {
    title: 'Platform settings',
    docRefs: {
      label: 'Where to read more',
      heading: 'Explained in the project documentation:',
      line: '{ref} — {kind}',
      kinds: { usecase: 'use case', case: 'use case edge case', rule: 'rule', adr: 'architecture decision (ADR)' },
    },
    subtitle: 'How the server and the interface work. Values saved here override the server environment.',
    search: 'Search by description and key',
    searchHint: 'Key, key words, description or GR_…',
    onlyChanged: 'Changed only',
    found: 'Showing {shown} of {total}',
    nothingFound: 'Nothing found',
    groups: { primary: 'Main', secondary: 'Secondary' },
    on: 'On',
    off: 'Off',
    sections: {
      features: 'Features',
      server: 'Server',
      database: 'Database',
      storage: 'File storage',
      media: 'Media',
      auth: 'Sign-in and sessions',
      initialData: 'First start',
      jobs: 'Periodic jobs',
      tasks: 'Background tasks',
      coordination: 'Multiple instances',
      realtime: 'Real-time events',
      demo: 'Demo',
      testMode: 'Test mode',
      ui: 'Interface',
    },
    sources: { default: 'Default', env: 'Server environment', saved: 'Saved' },
    restartApply: 'On restart',
    pendingRestart: 'Pending restart',
    envOnly: 'Environment only',
    secret: 'Secret',
    secretSet: 'Set',
    notSet: 'Not set',
    afterRestart: 'After restart',
    envOverridden: 'Environment {env} — overridden',
    envName: 'Environment variable',
    saved: 'Saved',
    savedBy: '{value} — {login}, {at}',
    defaultValue: 'Default',
    savedInvalid: 'The saved value is invalid and not applied: the environment or default value is in effect.',
    envOnlyHint: 'Changed only in the server environment ({env}) with a restart.',
    notSaved: 'Not saved',
    savedWithWarnings: 'Saved',
    warnings: {
      ENV_OVERRIDDEN: 'The value overrides the environment variable {env}: it has no effect until the saved value is reset.',
      RESTART_REQUIRED: 'Takes effect after the server restarts.',
    },
    reset: 'Reset saved value',
    personal: 'Personal',
    personalHint: 'Users can set their own value in their profile — it overrides this one.',
    readOnlyTitle: 'Demo mode: view only',
    readOnly: 'The demo is shared by all visitors and runs next to the production system, so platform settings cannot be changed here.',
    enabled: 'Enabled',
    range: 'From {min} to {max}',
    listRange: '{minItems} to {maxItems} comma-separated numbers, each from {min} to {max}',
    units: { ms: 'ms', seconds: 's', minutes: 'min', hours: 'h', kb: 'KB', mb: 'MB', gb: 'GB', px: 'px' },
  },
};
